var _defs, _path, _circle, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInterviewBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 190,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_357_97107",
    x1: 6.64682e-7,
    y1: 48,
    x2: 48.8676,
    y2: 47.0327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#048467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#064871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#6831A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C384D"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.863 3.44312C22.5463 1.59557 25.4537 1.59557 27.137 3.44312C28.2537 4.66874 29.9818 5.1318 31.5617 4.62871C33.9433 3.87033 36.4612 5.32405 36.9952 7.76573C37.3494 9.38547 38.6145 10.6506 40.2343 11.0048C42.6759 11.5388 44.1297 14.0567 43.3713 16.4383C42.8682 18.0182 43.3313 19.7463 44.5569 20.863C46.4044 22.5463 46.4044 25.4537 44.5569 27.137C43.3313 28.2537 42.8682 29.9818 43.3713 31.5617C44.1297 33.9433 42.6759 36.4612 40.2343 36.9952C38.6145 37.3494 37.3494 38.6145 36.9952 40.2343C36.4612 42.6759 33.9433 44.1297 31.5617 43.3713C29.9818 42.8682 28.2537 43.3313 27.137 44.5569C25.4537 46.4044 22.5463 46.4044 20.863 44.5569C19.7463 43.3313 18.0182 42.8682 16.4383 43.3713C14.0567 44.1297 11.5388 42.6759 11.0048 40.2343C10.6506 38.6145 9.38547 37.3494 7.76573 36.9952C5.32405 36.4612 3.87033 33.9433 4.62871 31.5617C5.1318 29.9818 4.66874 28.2537 3.44312 27.137C1.59557 25.4537 1.59557 22.5463 3.44312 20.863C4.66874 19.7463 5.1318 18.0182 4.62871 16.4383C3.87033 14.0567 5.32405 11.5388 7.76573 11.0048C9.38547 10.6506 10.6506 9.38547 11.0048 7.76573C11.5388 5.32405 14.0567 3.87033 16.4383 4.62871C18.0182 5.1318 19.7463 4.66874 20.863 3.44312Z",
    fill: "url(#paint0_linear_357_97107)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 24,
    cy: 24,
    r: 16.9263,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8884 19.5537C22.8884 21.3954 21.3954 22.8884 19.5537 22.8884C17.712 22.8884 16.2189 21.3954 16.2189 19.5537C16.2189 17.7119 17.712 16.2189 19.5537 16.2189C21.3954 16.2189 22.8884 17.7119 22.8884 19.5537Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.781 19.5537C31.781 21.3954 30.288 22.8884 28.4463 22.8884C26.6046 22.8884 25.1116 21.3954 25.1116 19.5537C25.1116 17.7119 26.6046 16.2189 28.4463 16.2189C30.288 16.2189 31.781 17.7119 31.781 19.5537Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.256 31.781C27.3079 31.418 27.3348 31.0469 27.3348 30.6695C27.3348 28.8518 26.7115 27.1798 25.6671 25.8553C26.4847 25.3823 27.4339 25.1116 28.4463 25.1116C31.5159 25.1116 34.0042 27.5999 34.0042 30.6695V31.781H27.256Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5537 25.1116C22.6232 25.1116 25.1116 27.5999 25.1116 30.6695V31.781H13.9958V30.6695C13.9958 27.5999 16.4841 25.1116 19.5537 25.1116Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewBadge);
export default __webpack_public_path__ + "static/media/interview-badge.46777b89b6b98a4af81ab76496262338.svg";
export { ForwardRef as ReactComponent };